<script>
  export default {
    name: 'dashboard-support'
  }
</script>

<template>
  <section>
    <h5>Support</h5>

    <div class="support card">
      <b-row>
        <b-col sm="12" class="content">
          <h2>Need help?</h2>
          <p>Visit our knowledge center or get in touch with our support team.</p>

          <b-button variant="primary" class="mb-3">Knowledge Center</b-button>
          <br>
          <b-button variant="primary">Contact Us</b-button>
        </b-col>
      </b-row>
      <img src="/img/dashboard/support_bg.png" srcset="/img/dashboard/support_bg@2x.png 2x" alt="">
    </div>
  </section>
</template>

<style src="./DashboardSupport.scss" lang="scss" scoped></style>
